import { IEvent } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { getIdFromPath } from "shared/utils";

export const getEventBandId = (event: Pick<IEvent, "band">) => {
  const bandPath = typeof event.band === "string" ? event.band : event.band?.id;
  const bandId = getIdFromPath(bandPath, API_ENDPOINTS.BANDS);

  return bandId;
};
